import { render, staticRenderFns } from "./chatDataList-old.vue?vue&type=template&id=483d9992&scoped=true&"
import script from "./chatDataList-old.vue?vue&type=script&lang=js&"
export * from "./chatDataList-old.vue?vue&type=script&lang=js&"
import style0 from "./chatDataList-old.vue?vue&type=style&index=0&id=483d9992&scoped=true&lang=css&"
import style1 from "./chatDataList-old.vue?vue&type=style&index=1&id=483d9992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d9992",
  null
  
)

export default component.exports